import React from 'react';
interface SectionProps {
  id?: string;
  children: React.ReactNode;
  className?: string;
  width?: 'default' | 'narrow';
  'aria-labelledby'?: string;
}
export function Section({
  id,
  children,
  className = '',
  width = 'default',
  ...rest
}: SectionProps) {
  return <section id={id} className={`w-full px-5 py-14 sm:px-8 md:py-20 lg:py-24 ${className}`} {...rest} style={{
    paddingTop: "30px"
  }} data-id="element-524" data-mp="2r62ku7dw8hjv">
      <div className={`mx-auto w-full ${width === 'narrow' ? 'max-w-3xl' : 'max-w-container'}`} data-id="element-525" data-mp="35u5pndg79n73">
        {children}
      </div>
    </section>;
}
interface EyebrowHeadingProps {
  id?: string;
  children: React.ReactNode;
  align?: 'left' | 'center';
  className?: string;
}
export function SectionHeading({
  id,
  children,
  align = 'left',
  className = ''
}: EyebrowHeadingProps) {
  return <h2 id={id} className={['font-sans text-[1.75rem] font-bold leading-[1.15] tracking-tight text-forest sm:text-4xl', align === 'center' ? 'text-center' : '', className].join(' ')} data-id="element-526" data-mp="1kguawz0jt24w">
      {children}
    </h2>;
}